import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, null, -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex gap-6" }

import { createSignalR, disconnect } from "@/core/plugins/signalr";
import { ref } from "vue";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebSocket',
  setup(__props) {

const isLoading = ref(false);
const mySignalR = ref<any>(null);
const baseUrl = ref(
  "https://thebcr.com/live/trade/symbol-group-hub?accountTypes=Advantage&accountTypes=Affilicate&accountTypes=Real"
);
const testWsSignalR = async () => {
  console.log("<<<<<<testWsSignalR");
  isLoading.value = true;
  const accountTypes = ["Advantage", "Affilicate", "Real"];
  // apply symbols as query string
  var queryString = new URLSearchParams();
  accountTypes.forEach((x) => queryString.append("accountTypes", x));
  // queryString.append("symbol", "EURUSD");
  try {
    const url = baseUrl.value;
    console.log("<<<<<<testWsSignalR>>>>>url", url);

    mySignalR.value = createSignalR(url);
    console.log("<<<<<<testWsSignalR>>>>>mySignalR", mySignalR.value);
    mySignalR.value.setup("xxxxx");

    await mySignalR?.value.connection?.start();
    console.log(
      "<<<<<<testWsSignalR>>>>>connection",
      mySignalR?.value.connection
    );
    notification.success();
  } catch (error) {
    console.error("Error connecting to WebSocket:", error);
    notification.danger();
  }

  isLoading.value = false;
};

const disconnectWs = async () => {
  console.log("<<<<<<disconnectWs");
  isLoading.value = true;
  if (mySignalR.value) {
    await mySignalR.value.connection.stop();
    mySignalR.value = null;
    notification.success();
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_input, {
          modelValue: baseUrl.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((baseUrl).value = $event)),
          type: "text",
          placeholder: "Enter WebSocket URL",
          disabled: isLoading.value
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: testWsSignalR,
          disabled: !baseUrl.value || isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Connect")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: !baseUrl.value || isLoading.value,
          type: "danger",
          onClick: disconnectWs
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Disconnect")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})